import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { ToasterService } from '../../shared/services/toaster.service';
import { LoginFlowService } from '../../shared/services/login-flow.service';
import { BaseResponse } from '../../_models/Response';

@Component({
  selector: 'app-sovos-callback',
  template: `
    <div style="min-height:70vh;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px">
      <mat-spinner diameter="48"></mat-spinner>
      <p>Completing your Sovos sign-in, please wait…</p>
    </div>`,
})
export class SovosCallbackComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthService,
    private toaster: ToasterService,
    private loginFlow: LoginFlowService,
  ) {}

  ngOnInit(): void {
    const code = this.route.snapshot.queryParamMap.get('code');
    const state = this.route.snapshot.queryParamMap.get('state');
    if (!code || !state) {
      this.toaster.error('Sign-in failed: missing code or state in URL.');
      this.router.navigateByUrl('/auth/login');
      return;
    }
    this.auth.sovosCallback(code, state).subscribe({
      next: (response: BaseResponse) => {
        const userid =
          response?.response?.userId ?? response?.response?.email ?? localStorage.getItem('userid') ?? '';
        if (response?.status === 1) {
          this.loginFlow.handleLoginResponse(response, userid);
        }else if (response?.status === 0 ) {
          if (
              response.response?.consentGiven === 0 &&
              response.message === 'Consent not received from the user'
            ) {
              this.router.navigate(['/auth/login'], {
                state: {
                  openConsent: true,
                  userId: userid
                }
              });
              return;
            }  
            this.loginFlow.handleLoginResponse(response, userid);    
        } else {
          this.toaster.warning(response?.message || `Sovos sign-in failed (status: ${response?.status})`);
          this.router.navigateByUrl('/auth/login');
        }
      },
      error: (err) => {
        const status = err?.status;
        const msg =
          err?.error?.message ||
          err?.message ||
          (status === 401
            ? 'Sovos code rejected (401). Code may be expired, already used, or issued for dev.app not localhost.'
            : status === 404
              ? 'Callback API not found (404). Confirm /sovos/auth/callback is deployed on dev API.'
              : 'Sign-in failed. Please try again.');
        console.error('Sovos callback failed', { status, url: err?.url, error: err?.error });
        this.toaster.error(msg);
        this.router.navigateByUrl('/auth/login');
      },
    });
  }
}
